import React, { ReactNode, useEffect } from "react";
import { currentUser, legit } from "apex-legit-service";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Location } from "history";

import { LEGIT_SERVICE_CONFIG, ALL_REQUESTED_PERMISSIONS } from "common";
import { RootAction, RootState } from "StoreTypes";
import ApexLogin from "containers/ApexLogin";
import ApexFooter from "components/ApexFooter";
import ApexHeader from "components/ApexHeader";
import { FormattedMessage } from "react-intl";
import { NavLinkProps } from "../../types";
import messages from "./messages";

interface Props {
  render: () => ReactNode;
  links: NavLinkProps[];
  location: Location;
  orgUnits: string[];
  isActiveLink: (index: number) => boolean;
  adoptLegitSession: (
    config: Record<string, any>,
    requestedPermissions: string[]
  ) => void;
  logout: (config: Record<string, any>, params: { apexUser: boolean }) => void;
  showLogin: boolean;
  showAppContent: boolean;
}

const App = ({
  render,
  links,
  isActiveLink,
  adoptLegitSession,
  logout,
  showLogin,
  showAppContent,
}: Props) => {
  useEffect(() => {
    adoptLegitSession(LEGIT_SERVICE_CONFIG, ALL_REQUESTED_PERMISSIONS);
  }, []);

  function handleLogout() {
    const params = { apexUser: false };
    logout(LEGIT_SERVICE_CONFIG, params);
  }

  return (
    <div>
      <ApexHeader
        title={<FormattedMessage {...messages.title} />}
        links={links}
        isActiveLink={isActiveLink}
        onLogoutClick={handleLogout}
        showLogout={!showLogin}
      />
      {showLogin && <ApexLogin />}
      {showAppContent && render()}
      <ApexFooter />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  showLogin: legit.selectors.selectShowLoginUI(state) === legit.LOGIN_UI_SHOW,
  showLogout: legit.selectors.selectShowLogoutUI(state),
  showAppContent:
    legit.selectors.selectShowLoginUI(state) === legit.LOGIN_UI_HIDE,
  orgUnits: currentUser.selectors.selectResults(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) =>
  bindActionCreators(
    {
      adoptLegitSession: legit.adoptExistingSession,
      login: legit.login,
      logout: legit.logout,
    },
    dispatch
  );

export { default as sagas } from "./sagas";

export default connect(mapStateToProps, mapDispatchToProps)(App);
